export default __webpack_public_path__ + "static/media/subFrame1.18e1860d.png";